import {
  Transaction,
  TransactionState,
  TransactionStateMapped
} from 'data/Payments/Transactions/types'

// TODO: As part of open banking we started serving CHARGE transactions in deposits
// that transactions can have more states than included in TransactionState
// some of them mean we already credited the funds so we map them to COMPLETE on the UI

const PAYED_STATES = ['COMPLETE', 'FINISHED']
const FAILED_STATES = ['FAILED', 'REJECTED', 'REFUNDED', 'CANCELED']
export const mapState = (
  state: TransactionState | TransactionStateMapped
): TransactionState | TransactionStateMapped =>
  PAYED_STATES.includes(state)
    ? TransactionStateMapped.Complete
    : FAILED_STATES.includes(state)
    ? TransactionStateMapped.Failed
    : TransactionStateMapped.Processing
const mapPaymentState = (transaction: Transaction): Transaction => ({
  ...transaction,
  state: mapState(transaction.state)
})

export default mapPaymentState
